import { useQuery } from 'react-query'
import { useAuth0 } from '../../../contexts/auth0-context'
import callAPI from '../../../API/callSecureAPI'
import { GroupedChange, ChangeLogFilters } from '../types'

export const useGetTPPChangeLogQuery = (tppId: string | null, filters: ChangeLogFilters = {}) => {
    const { getTokenSilently, isAuthenticated, isLoading } = useAuth0()

    const getChangeLog = async () => {
        try {
            const token = await getTokenSilently?.({ audience: 'https://atlas.aesara.com' })

            const params = new URLSearchParams()
            if (filters.columnId) params.append('columnId', filters.columnId)
            if (filters.limit) params.append('limit', filters.limit.toString())
            if (filters.offset) params.append('offset', filters.offset.toString())

            const queryString = params.toString()
            const url = `/api/changes/tpp/${tppId}${queryString ? `?${queryString}` : ''}`

            const response = await callAPI(url, 'get', token)

            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    return useQuery<GroupedChange[]>(['tppChangeLog', tppId, filters.columnId], getChangeLog, {
        enabled: !!getTokenSilently && !!isAuthenticated && !isLoading && !!tppId,
        staleTime: 0,
        refetchOnMount: 'always',
        refetchOnWindowFocus: false,
        retry: 3,
    })
}
